// extracted by mini-css-extract-plugin
module.exports = {"indicator":"LoadingIndicator_indicator__1eZS2"};